// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"thumb-placeholder_placeholder__1mi7W","title":"thumb-placeholder_title__2gZI8","circle":"thumb-placeholder_circle__3nuXP"};